import { PRIVILEGE } from 'constants/privilege';
import withAccessControl from 'hoc/withAccessControl';
import { usePrivileges } from 'hooks/useAuth';
import CampaignCreationLayout from 'Layouts/CampaignCreationLayout'
import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Spinner } from 'reactstrap';
import { updateCampaignMilestone } from 'services/api/campaign';
import { RootState, AppDispatch } from 'store';
import { Milestone } from 'types/campaign/collaborations';

const CampaignPaymentTerms = () => {
    const { campaignId } = useParams();

    const selectedAgencyId = useSelector((state: RootState) => state.auth.selectedAgencyId);
    const milestonesData = useSelector((state: RootState) => state.campaignMilestones.items[campaignId!]?.milestonesData);
    const campaignMilestones = milestonesData?.milestones ?? [];
    const [errors, setErrors] = useState<{ [key: string]: string }>({});

    const dispatch: AppDispatch = useDispatch();
    const navigate = useNavigate();

    const [searchParams] = useSearchParams();
    const validate = searchParams.get('validate');
    const [validatedOnce, setValidatedOnce] = useState(false);
    

    const [loading, setLoading] = React.useState<boolean>(false);
    const privileges = usePrivileges();
    const campaignMilestone = (Array.isArray(campaignMilestones) && campaignMilestones.length > 0) ? campaignMilestones[0] : null;

    const [milestone, setMilestone] = useState(campaignMilestone ?? null);

    useEffect(() => {
        setMilestone(campaignMilestone ?? null);
    }, [campaignMilestone])

      useEffect(() => {
            if(validate === 'true' && milestone && !validatedOnce){
                validateMilestoneData();
                setValidatedOnce(true);
            }
        }, [validate, milestone, validatedOnce])

    const validateMilestoneData = () => {
        if (!milestone) return false;
        const validation_errors: { [key: string]: string } = {};
        if (!milestone.gig_amount || isNaN(Number(milestone.gig_amount)) || Number(milestone.gig_amount) < 0) {
            validation_errors.gig_amount = 'Please enter a valid amount.'
        }

        if (!milestone.payment_days || isNaN(Number(milestone.payment_days)) || Number(milestone.payment_days) < 0) {
            validation_errors.payment_days = 'Please enter a valid number of days.'
        }

        setErrors(validation_errors);

        return !(Object.values(validation_errors).length > 0);

    }

    const submitPaymentTerms = async () => {
        if (!campaignId || !milestone?.id || !selectedAgencyId || !validateMilestoneData()) return;

        setLoading(true);
        try {
            await updateCampaignMilestone(selectedAgencyId, campaignId, String(milestone.id), milestone);
            navigate('/campaign/' + campaignId + '/banner');
        } catch (error) {
            toast.error('Failed to update milestone');
        } finally {
            setLoading(false);
        }
    }

    const handleMilestoneChange = (key: string, value: any) => {
        if (!milestone) return;
        const updatedMilestone: Milestone = {
            ...milestone,
            [key]: value
        };
        setMilestone(updatedMilestone);
    }

    const handleSpecificationsChange = (key: string, value: any) => {
        if (!milestone) return;
        const updatedMilestone: Milestone = {
            ...milestone,
            specifications: {
                ...milestone.specifications,
                [key]: value
            }
        };
        setMilestone(updatedMilestone);
    }


    return (
        <CampaignCreationLayout
            activeStep='payment-terms'
            actionRow={
                <div className="d-flex justify-content-between mb-4">
                    <div></div>
                    <button type='button' onClick={submitPaymentTerms} disabled={loading || !privileges.includes(PRIVILEGE.CAMPAIGN.CAMPAIGN.EDIT)} className="theme-btn theme-btn-lg btn-gradient form-continue-btn d-flex justify-content-between align-items-center">
                        <React.Fragment>
                            {
                                'Proceed to Next'
                            }
                            {
                                loading ? <Spinner size="sm" className='me-2'> Loading... </Spinner> : <i className='bx fs-4 bx-right-arrow-alt' ></i>
                            }
                        </React.Fragment>
                    </button>
                </div>
            }
        >
            <div>
                <div className="form-group m-0">
                    <div className="d-flex flex-column">
                        <label htmlFor="max-gigs">Fee per creator <span className="text-danger">*</span></label>
                        <span className='field-desc'>Enter the fee to be paid to each creator for this campaign.</span>
                    </div>
                    <input
                        type="number"
                        id="influencer-budget"
                        className="form-control"
                        value={milestone?.gig_amount || ''}
                        onChange={(e) => handleMilestoneChange('gig_amount', Number(e.target.value) ? Number(e.target.value) : '')}
                        placeholder="Enter fee per creator" />
                    {errors['gig_amount'] &&
                        <span className="text-danger">{errors['gig_amount']}</span>
                    }
                </div>
                <div className="form-group mt-4">
                    <div className="d-flex flex-column">
                        <label htmlFor="max-gigs">Payment Days <span className="text-danger">*</span></label>
                        <span className='field-desc'>Enter the number of days after collaboration is completed when creators will receive their payment.</span>
                    </div>
                    <input
                        type="number"
                        id="payment-days"
                        className="form-control"
                        value={milestone?.payment_days || ''}
                        onChange={(e) => handleMilestoneChange('payment_days', Number(e.target.value) ? Number(e.target.value) : '')}
                        placeholder="Enter fee per creator" />
                    {errors['payment_days'] &&
                        <span className="text-danger">{errors['payment_days']}</span>
                    }
                </div>
            </div>
        </CampaignCreationLayout>
    )
}

export default withAccessControl(CampaignPaymentTerms, PRIVILEGE.CAMPAIGN.CAMPAIGN.EDIT)
